import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';

import { CookieService } from 'angular2-cookie/services/cookies.service';
import {
    MarketmanagerSharedLibsModule,
    MarketmanagerSharedCommonModule,
    CSRFService,
    AuthService,
    AuthServerProvider,
    AccountService,
    UserService,
    StateStorageService,
    LoginService,
    LoginModalService,
    Principal,
    JhiTrackerService,
    HasAnyAuthorityDirective,
    JhiLoginModalComponent
} from './';
import {NavbarService} from "../layouts/navbar/navbar.service";

@NgModule({
    imports: [
        MarketmanagerSharedLibsModule,
        MarketmanagerSharedCommonModule
    ],
    declarations: [
        JhiLoginModalComponent,
        HasAnyAuthorityDirective
    ],
    providers: [
        CookieService,
        LoginService,
        LoginModalService,
        AccountService,
        StateStorageService,
        Principal,
        CSRFService,
        JhiTrackerService,
        AuthServerProvider,
        AuthService,
        UserService,
        DatePipe,
        NavbarService
    ],
    entryComponents: [JhiLoginModalComponent],
    exports: [
        MarketmanagerSharedCommonModule,
        JhiLoginModalComponent,
        HasAnyAuthorityDirective,
        DatePipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class MarketmanagerSharedModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared.module.ts